module.exports = __webpack_public_path__ + "media/right.05363d10.wav";